/* import __COLOCATED_TEMPLATE__ from './outbound-post.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import type PartGroup from 'embercom/objects/inbox/conversation-stream/part-group';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import { type SenderSummary } from 'embercom/objects/inbox/renderable/post';
import type Post from 'embercom/objects/inbox/renderable/post';
import { OutboundInitialPartSenderType } from 'embercom/objects/inbox/outbound-initial-part-sender-types';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';

interface OutboundPostRenderablePart extends RenderablePart {
  renderableData: Post;
}

interface OutboundChatPartGroup extends PartGroup {
  parts: Array<OutboundPostRenderablePart>;
}

interface Args {
  partGroup: OutboundChatPartGroup;
  isReadOnly: boolean;
}

interface Signature {
  Args: Args;
}

export default class ConversationStreamTeammateContentComponent extends Component<Signature> {
  @service declare session: Session;
  get renderableData() {
    return this.args.partGroup.parts[0].renderableData;
  }

  get sender(): SenderSummary {
    return this.renderableData.senderSummary;
  }

  get senderIsTeammate() {
    return this.renderableData.senderType === OutboundInitialPartSenderType.Admin;
  }

  get senderIsTeam() {
    return this.renderableData.senderType === OutboundInitialPartSenderType.Team;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::PartGroups::OutboundPost': typeof ConversationStreamTeammateContentComponent;
    'inbox2/conversation-stream/part-groups/outbound-post': typeof ConversationStreamTeammateContentComponent;
  }
}
